import { useState, useEffect } from 'react';
export var ScrollDirection;
(function (ScrollDirection) {
    ScrollDirection[ScrollDirection["DOWN"] = 1] = "DOWN";
    ScrollDirection[ScrollDirection["UP"] = -1] = "UP";
})(ScrollDirection || (ScrollDirection = {}));
export function maxIndex(data, limitNumberOfListItem) {
    var maxBound = Math.min(data.length, limitNumberOfListItem);
    return maxBound - 1;
}
// eslint-disable-next-line max-lines-per-function, complexity, max-statements
export var useManageAutoComplete = function (_a) {
    var initialData = _a.data, defaultValue = _a.defaultValue, limitNumberOfListItem = _a.limitNumberOfListItem, onPressEnterOnItem = _a.onPressEnterOnItem, refAutoCompletion = _a.refAutoCompletion, minNumberOfCharactersForAutocomplete = _a.minNumberOfCharactersForAutocomplete, bottomButtonClickHandler = _a.bottomButtonClickHandler, update = _a.update;
    var _b = useState(null), currentIndex = _b[0], setCurrentIndex = _b[1];
    var _c = useState(initialData), data = _c[0], setData = _c[1];
    var _d = useState(defaultValue), value = _d[0], setValue = _d[1];
    var _e = useState(false), showAutoCompletion = _e[0], setShowAutoCompletion = _e[1];
    var _f = useState(ScrollDirection.DOWN), scrollDirection = _f[0], setScrollDirection = _f[1];
    useEffect(function () {
        setCurrentIndex(null);
        setData(initialData);
    }, [initialData]);
    useEffect(function () {
        var listener = function (event) {
            var _a;
            if ((_a = refAutoCompletion === null || refAutoCompletion === void 0 ? void 0 : refAutoCompletion.current) === null || _a === void 0 ? void 0 : _a.contains(event === null || event === void 0 ? void 0 : event.target)) {
                return;
            }
            setShowAutoCompletion(false);
        };
        if (showAutoCompletion) {
            document.addEventListener('mousedown', listener);
            document.addEventListener('touchstart', listener);
        }
        else {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        }
    }, [showAutoCompletion]);
    var keysBindingActions = {
        ArrowDown: function () {
            if (showAutoCompletion) {
                setCurrentIndex(function (prev) {
                    if (prev === null && data.length > 0) {
                        return 0;
                    }
                    var maxIdx = maxIndex(data, limitNumberOfListItem);
                    if (maxIdx === -1 || prev === maxIdx) {
                        return -1;
                    }
                    return prev + 1;
                });
                setScrollDirection(ScrollDirection.DOWN);
            }
        },
        ArrowUp: function () {
            if (showAutoCompletion) {
                setCurrentIndex(function (prev) {
                    if (prev === null || prev <= 0) {
                        return null;
                    }
                    return prev - 1;
                });
                setScrollDirection(ScrollDirection.UP);
            }
        },
        Enter: function () {
            if (showAutoCompletion && currentIndex !== null) {
                var item = data[currentIndex];
                setValue(item.label);
                onPressEnterOnItem(item);
                setShowAutoCompletion(false);
            }
        },
        Escape: function () {
            setShowAutoCompletion(false);
        },
        Tab: function () {
            setShowAutoCompletion(false);
        }
    };
    var onSelected = function (item) {
        setValue(item === null || item === void 0 ? void 0 : item.label);
        setShowAutoCompletion(false);
    };
    var onKeyDownHandler = function (event) {
        var func = keysBindingActions[event.key];
        if (!func) {
            return;
        }
        if (event.key !== 'Tab') {
            event.preventDefault();
        }
        func();
    };
    var onInputHandler = function (event) {
        setValue(event.target.value);
        setShowAutoCompletion(event.target.value.length >= minNumberOfCharactersForAutocomplete);
        update === null || update === void 0 ? void 0 : update(event);
    };
    var onBottomButtonArrowUpOrEsc = function () {
        var maxIdx = maxIndex(data, limitNumberOfListItem);
        setCurrentIndex(maxIdx === -1 ? null : maxIdx);
    };
    var onBottomButtonClick = function () {
        setShowAutoCompletion(false);
        bottomButtonClickHandler === null || bottomButtonClickHandler === void 0 ? void 0 : bottomButtonClickHandler();
    };
    var onBottomButtonEsc = function () {
        setShowAutoCompletion(false);
    };
    return {
        currentItemIndex: currentIndex,
        value: value,
        setValue: setValue,
        onSelected: onSelected,
        onKeyDownHandler: onKeyDownHandler,
        showAutoCompletion: showAutoCompletion,
        onBottomButtonArrowUpOrEsc: onBottomButtonArrowUpOrEsc,
        onBottomButtonClick: onBottomButtonClick,
        onBottomButtonEsc: onBottomButtonEsc,
        onInputHandler: onInputHandler,
        scrollDirection: scrollDirection
    };
};
